
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CpDonutchartComponent } from './cp-donutchart.component';


@NgModule({
  declarations: [CpDonutchartComponent],
  exports: [CpDonutchartComponent],
  imports: [CommonModule]
})
export class DonutChartModule {}

